const registrations = new Map();
let nextRegistrationId = 0;

/**
 * Merge mounted page context registrations.
 * @return {object} current context
 */
function currentRegisteredContext() {
	return Array.from(registrations.values()).reduce(
		(context, patch) => ({...context, ...patch}),
		{},
	);
}

/**
 * Return safe browser page context without identity claims.
 * @return {object} page context
 */
export function getAgentPageContext() {
	return {
		route: window.location.pathname,
		section: null,
		...currentRegisteredContext(),
	};
}

/**
 * Register safe page context from a mounted Canvas page.
 * @param {object} context safe context patch
 * @return {Function} cleanup callback
 */
export function registerAgentPageContext(context) {
	nextRegistrationId += 1;
	const registrationId = nextRegistrationId;
	registrations.set(registrationId, context);
	return () => {
		registrations.delete(registrationId);
	};
}
